import { FC, useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { kColors } from "src/kColors";

interface PaginationProps {
  pages: number;
  currentPage: number;
  onSelect: (index: number) => void;
}

const Pagination: FC<PaginationProps> = ({ pages, currentPage, onSelect }) => {
  const [activePage, setActivePage] = useState(currentPage);

  const changePage = (myPageNum: number) => {
    if (myPageNum >= 1 && myPageNum <= pages) {
      onSelect(myPageNum);
      setActivePage(myPageNum);
    } else {
      throw new Error("Pagination index is out of range");
    }
  };

  const increment = () => {
    if (activePage + 1 <= pages) {
      changePage(activePage + 1);
    }
  };

  const decrement = () => {
    if (activePage > 1) {
      changePage(activePage - 1);
    }
  };

  const pagesArr: Array<number> = [];
  for (let i = 0; i < pages; i += 1) {
    pagesArr.push(i + 1);
  }
  return (
    <View style={styles.paginationContainer}>
      <TouchableOpacity
        onPress={decrement}
        disabled={activePage === 1}
        style={activePage === 1 ? styles.paginationDisabled : null}
      >
        <View style={[styles.paginationItem, styles.paginationFirstItem]}>
          <Text style={styles.paginationLabel}>&larr;</Text>
        </View>
      </TouchableOpacity>
      {pagesArr.map((myPage) => (
        <TouchableOpacity key={myPage} onPress={() => changePage(myPage)}>
          <View style={[styles.paginationItem, activePage === myPage ? styles.paginationActive : null]}>
            <Text style={styles.paginationLabel}>{myPage}</Text>
          </View>
        </TouchableOpacity>
      ))}
      <TouchableOpacity
        onPress={increment}
        disabled={activePage === pages}
        style={activePage === pages ? styles.paginationDisabled : null}
      >
        <View style={styles.paginationItem}>
          <Text style={styles.paginationLabel}>&rarr;</Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default Pagination;

const styles = StyleSheet.create({
  paginationActive: {
    backgroundColor: kColors.lightBlack,
  },
  paginationContainer: {
    flexDirection: "row",
    marginTop: 16,
  },
  paginationDisabled: {
    opacity: 0.5,
  },
  paginationFirstItem: {
    borderColor: kColors.lightBlack,
    borderStartWidth: 1,
  },
  paginationItem: {
    alignItems: "center",
    borderBottomWidth: 1,
    borderColor: kColors.lightBlack,
    borderEndWidth: 1,
    borderTopWidth: 1,
    height: 40,
    justifyContent: "center",
    width: 40,
  },
  paginationLabel: {
    color: kColors.gray,
    fontSize: 18,
  },
});
